/* Integer-cent pack pricing and lossless design/line mapping. Shared with Node checks. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SouvenirMagnetPricing = api;
})(typeof globalThis === 'object' ? globalThis : this, function () {
  'use strict';
  const prices = [0, 999, 1799, 2249, 2699, 3099, 3500, 3899, 4299];
  const maxCount = 1000;
  function total(count) {
    if (!Number.isInteger(count) || count < 0 || count > maxCount) throw Error('Please choose a valid magnet quantity. For orders over 1,000 magnets, contact us.');
    return count < 8 ? prices[count] : Math.round(prices[8] * count / 8);
  }
  function readCart(cart, catalog, packProductId) {
    const byId = new Map(catalog.map(d => [d.id, d]));
    const magnets = [], lines = [], others = [], invalid = [];
    for (const item of cart.items) {
      const isPack = String(item.product_id) === String(packProductId);
      const singleId = String(item.sku || '').replace(/-P1$/, '');
      if (!isPack && !byId.has(singleId)) { others.push(item); continue; }
      lines.push(item);
      let ids;
      if (!isPack) ids = [singleId];
      else {
        const match = /^MAG-MIX-P([1-8])$/.exec(item.sku || '');
        const count = match ? Number(match[1]) : /^MAG-MIX-V(?:LOW|HIGH)$/.test(item.sku || '') ? 1 : 0;
        ids = Array.from({length: count}, (_, i) => String(item.properties?.[`Magnet ${i + 1}`] || '').split(' | ')[0]);
        if (!count || ids.some(id => !byId.has(id))) { invalid.push(item); continue; }
      }
      for (let q = 0; q < item.quantity; q++) magnets.push(...ids);
    }
    total(magnets.length);
    return { magnets, lines, others, invalid };
  }
  function plan(ids, catalog, variants, transaction) {
    const byId = new Map(catalog.map(d => [d.id, d]));
    const expected = total(ids.length), items = [];
    if (ids.some(id => !byId.has(id))) throw Error('A selected magnet design is unavailable. Please review your cart.');
    function add(sku, selected, price) {
      const variant = variants.find(v => v.sku === sku);
      if (!variant || !variant.available || Number(variant.price) !== price) throw Error('Magnet pricing is being updated. Please try again later.');
      const properties = { 'Pack size': `${selected.length} magnet${selected.length === 1 ? '' : 's'}`, _magnet_version: '2', _magnet_transaction: transaction, _magnet_chunk: String(items.length) };
      selected.forEach((id, i) => { properties[`Magnet ${i + 1}`] = `${id} | ${byId.get(id).label.slice(0, 180)}`; });
      items.push({id: Number(variant.id), quantity: 1, properties});
    }
    if (ids.length && ids.length < 8) add(`MAG-MIX-P${ids.length}`, ids, expected);
    else {
      const full = Math.floor(ids.length / 8);
      for (let i = 0; i < full; i++) add('MAG-MIX-P8', ids.slice(i * 8, i * 8 + 8), prices[8]);
      const rest = ids.slice(full * 8);
      const highCents = expected - full * prices[8] - rest.length * 537;
      rest.forEach((id, i) => add(i < highCents ? 'MAG-MIX-VHIGH' : 'MAG-MIX-VLOW', [id], i < highCents ? 538 : 537));
    }
    return {items, expected};
  }
  function sameLines(actual, expected) {
    if (actual.length !== expected.length) return false;
    return expected.every(want => actual.some(item => String(item.variant_id) === String(want.id) && item.quantity === want.quantity && Object.keys(want.properties).every(k => item.properties?.[k] === want.properties[k])));
  }
  return {total, readCart, plan, sameLines, prices, maxCount};
});
